import {
  IOpportunity,
  TComplexSectionData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'
import { useMemo } from 'react'

import { useTableActions } from '../../hooks/useTableActions'
import { StyledTable } from '../styledComponents/styledTable/StyledTable'
import { Title } from '../styledComponents/title/Title'

import { getBusinessTypeCrud } from './helpers/getBusinessTypeCrud'
import { getInitialOpportunitiesData } from './helpers/getInitialOpportunitiesData'
import { getOpportunitiesColumns } from './helpers/getOpportunitiesColumns'
import { getYearAndQuarterCrud } from './helpers/getYearAndQuarterCrud'

import styles from './Opportunities.module.scss'

interface IProps {
  fYear: number
  data: IOpportunity[]
  updateFormData: (data: TComplexSectionData) => void
  title?: string
}

export const Opportunities = ({ data, updateFormData, title, fYear }: IProps) => {
  const { addRow, deleteRow, deleteLastRow, onChange, canAddNewRow } =
    useTableActions<IOpportunity>({
      updateFormData: updateFormData,
      data: data,
      newEmptyRow: getInitialOpportunitiesData()[0],
      canAddNewRowCondFn: (el) => !el.TopDeal && !el.TotalUSD && !el.CloseDate,
    })

  const yearsAndQuartersSource = useMemo(() => getYearAndQuarterCrud(fYear), [fYear])
  const businessTypeSource = useMemo(() => getBusinessTypeCrud(), [])

  const columns = useMemo(
    () => getOpportunitiesColumns({ onChange, yearsAndQuartersSource, businessTypeSource }),
    [data]
  )

  return (
    <div className={styles.root}>
      <RenderWhen condition={!!title}>
        <Title variant="withBackground" text={title || ''} />
      </RenderWhen>

      <StyledTable<IOpportunity>
        canAddNewRow={canAddNewRow}
        columns={columns}
        items={data}
        addRow={addRow}
        deleteLastRow={deleteLastRow}
        deleteRow={deleteRow}
        maxLen={5}
      />
    </div>
  )
}
